import axios from "axios";

// systemAdmin-only: drive the onboarding-report answers backfill.
const start = () => axios.post("api/v1/admin/onboarding-reports/backfill/start");
const stop = () => axios.post("api/v1/admin/onboarding-reports/backfill/stop");
const getStatus = () => axios.get("api/v1/admin/onboarding-reports/backfill/status");

const ApiOnboardingReportBackfill = { start, stop, getStatus };

export default ApiOnboardingReportBackfill;
